import {Fragment, PureComponent} from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'

import AskReinforcement from '../../../components/AskReinforcement/AskReinforcement.jsx'
import CalendlyButton from '../../../components/CalendlyButton/CalendlyButton.jsx'
import Header from '../../../components/Header/Header.jsx'
import Landing from '../Landing.jsx'
import OurDifferences from '../../../components/OurDifferences/OurDifferences.jsx'
import OurJobs from '../../../components/OurJobs/OurJobs.jsx'
import References from '../../../components/References/References.jsx'

import {generate} from '../../../routes.js'
import conf from '../../../conf.js'

import header from './images/header.jpg?size=600'
import person from './images/person.svg'
import shield from './images/shield.svg'
import engineeringImg from './images/engineering.png?size=600'
import financeImg from './images/finance.jpg?size=600'
import purchaseImg from './images/purchase.jpg?size=600'
import hrImg from './images/hr.jpg?size=600'

const headerBrief = <Fragment>
  <p><strong>Besoin d’un renfort, d’un expert ou d’un manager de transition ?</strong> Twineeds vous connecte immédiatement à des <strong>consultants qualifiés</strong> pour vos <strong>projets stratégiques ou opérationnels</strong> : mission ponctuelle, structuration d’équipe, transition managériale ou expertise ciblée.</p>
</Fragment>

const title = "Twineeds | Trouvez rapidement un consultant expert"
const description = "Partagez vos besoins en consultants experts et accédez à des profils qualifiés en ingénierie et fonctions support (Achats, Supply, Finance, RH)."

const ourJobsItems = [
  {
    title: 'Achats et Supply Chain',
    brief: '<p>Faites appel à un <strong>consultant achats & supply chain</strong> immédiatement opérationnel : acheteur IT, SRM, contract manager, responsable logistique, gestionnaire de flux, chef de projet supply.</p>',
    img: purchaseImg.src,
    imgAlt: 'Équipe concentrée sur un projet stratégique devant un PC'
  },
  {
    title: 'Finance',
    brief: '<p>Trouvez un <strong>consultant en finance</strong> pour renforcer ou structurer votre direction : DAF, RAF, contrôleur de gestion, trésorier, analyste financier, expert-comptable ou gestionnaire de paie.</p>',
    img: financeImg.src,
    imgAlt: 'Consultant finance conseille une entreprise autour d\'un bureau'
  },
  {
    title: 'Ingénierie Technique',
    brief: '<p>Un <strong>consultant en ingénierie technique</strong> (hors IT) pour vos <strong>projets industriels, R&D ou QHSE</strong> : ingénieur méthodes, maintenance, génie civil ou aéronautique.</p>',
    img: engineeringImg.src,
    imgAlt: 'Consultants ingénieurs en ingénierie mécanique collaborant sur un projet technique'
  },
  {
    title: 'Ressources Humaines',
    brief: '<p>Confiez votre projet RH à un <strong>profil expérimenté</strong> : gestionnaire de paie, chargé de recrutement, consultant SIRH, RH en droit social ou DRH de transition.</p>',
    img: hrImg.src,
    imgAlt: 'Consultante experimentée conseille une entreprise devant un PC'
  }
]

class LandingCompany extends PureComponent {
  render() {
    const headerCtas = <Fragment>
      <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Proposer une mission</Link>
      <CalendlyButton className="btn btn-secondary" meetingUrl={conf.calendly.do}>Être rappelé(e)</CalendlyButton>
    </Fragment>

    return <Landing
      className="landing-company"
      helmet={{title, description}}
    >
      <Header
        brief={headerBrief}
        ctas={headerCtas}
        imageAlt={'Consultant indépendant conseille entreprise en regardant des documents'}
        imageSrc={header.src}
        title="Trouvez des consultants qualifiés en Ingénierie, Achats, Supply, Finance ou RH"
      />

      <div className="bg-light">
        <References className="container text-center py-5"/>
      </div>

      <OurJobs items={ourJobsItems}/>

      <div className="bg-light">
        <AskReinforcement/>
      </div>

      <OurDifferences specificDifference={
        <Fragment>
          <strong>Un réseau de consultants spécialisés</strong> pour structurer vos projets transverses et accompagner le changement.
        </Fragment>
      }/>

      <div className="bg-light">
        <section id="benefits" className="container py-5">
          <div className="row text-center">
            <div className="col-md-6 pl-md-5 mb-4 mb-md-0">
              <img className="mb-4" src={person} alt={''}/>
              <h3>100% de consultants qualifiés</h3>
              <p>
                Tous nos consultants ont été rencontrés et qualifiés par des professionnels de LEUR métier, afin de
                vous assurer de la réelle adéquation entre vos besoins et leurs qualifications.
              </p>
            </div>
            <div className="col-md-6 pr-md-5 mb-4 mb-md-0">
              <img className="mb-4" src={shield} alt={''}/>
              <h3>Quels sont les risques de requalification ?</h3>
              <p>
                Vous êtes parfaitement protégés contre les risques de prêt de main d'œuvre illicite et de délit de
                marchandage !
              </p>
              <Link className="btn btn-primary" to={generate({name: 'legal'})}>En savoir plus</Link>
            </div>
          </div>
        </section>
      </div>
    </Landing>
  }
}

export default connect(
  state => ({
    universes: state.universe.universes,
  })
)(LandingCompany)
